export default __webpack_public_path__ + "alberta-diagnosis.520cce6d7ae794a020f6.svg";